import React from 'react';
import { useParams } from 'react-router-dom';
import SEO from './SEO';
import { BLOG_POSTS } from './Blog';

function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find(p => p.slug === slug);

  if (!post) {
    return <div className="max-w-3xl mx-auto py-16 text-center text-2xl text-gray-500">Blog post not found.</div>;
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    'headline': post.slug === 'safe-power-washing-pebbletec-pools' ? 'Safe Power Washing for PebbleTec Pools: Pro Tips' : post.title,
    'image': post.image,
    'author': {
      '@type': 'Person',
      'name': 'Giovanni Spadafore',
      'url': 'https://coppercanyonpressurewash.com/about-the-author'
    },
    'datePublished': post.date,
    'dateModified': post.date,
    'description': post.summary,
    'articleBody': post.content ? post.content.map(c => c.text || c.items?.join(', ')).join('\n') : '',
    'publisher': {
      '@type': 'Organization',
      'name': 'Copper Canyon Pressure Wash',
      'logo': {
        '@type': 'ImageObject',
        'url': [
          'https://coppercanyonpressurewash.com/Copper Canyon Pressure Wash_final logo.avif',
          'https://coppercanyonpressurewash.com/Copper Canyon Pressure Wash_final logo.webp',
          'https://coppercanyonpressurewash.com/Copper Canyon Pressure Wash_final logo.png'
        ]
      },
      'mainEntityOfPage': {
        '@type': 'WebPage',
        '@id': `https://coppercanyonpressurewash.com/blog/${slug}`
      }
    }
  };

  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <SEO 
        title={post.slug === 'cleaning-house-siding-tips' ? 'How to Clean Every Type of House Siding: Pro Tips' : post.title}
        description={post.summary}
        image={post.image}
        type="article"
        schema={schema}
        author="Giovanni Spadafore"
        keywords="pressure washing, house siding, cleaning tips, vinyl, brick, wood, stucco, home maintenance, exterior cleaning, property care, Phoenix"
      />
      <article>
        <img src={post.image} alt={post.title} className="w-full h-64 object-cover rounded mb-8" />
        <h1 className="text-4xl font-bold text-[#4a3f35] mb-4">{post.title}</h1>
        <div className="flex items-center text-sm text-gray-500 mb-6">
          <span>By <a href="/about-the-author" className="text-[#b87c4c] hover:underline">Giovanni Spadafore</a></span>
          <span className="mx-2">•</span>
          <span>{new Date(post.date).toLocaleDateString()}</span>
        </div>
        <p className="text-lg text-gray-700 mb-8 italic">{post.summary}</p>
        <div className="prose prose-lg max-w-none">
          {post.content && post.content.map((block, idx) => {
            if (block.type === 'paragraph') return <p key={idx} className="mb-6 text-gray-800 leading-relaxed">{block.text}</p>;
            if (block.type === 'heading') return <h2 key={idx} className="text-2xl font-bold text-[#b87c4c] mt-10 mb-4">{block.text}</h2>;
            if (block.type === 'list') return (
              <ul key={idx} className="list-disc pl-6 mb-6 space-y-2">
                {block.items.map((item, i) => <li key={i} className="text-gray-700 leading-relaxed">{item}</li>)}
              </ul>
            );
            if (block.type === 'quote') return <blockquote key={idx} className="border-l-4 border-[#b87c4c] pl-4 italic text-[#4a3f35] my-6">{block.text}</blockquote>;
            return null;
          })}
        </div>
      </article>
    </main>
  );
}

export default BlogPost; 